import React from 'react';
import { withRouter } from 'react-router';
import { VideoPlayer } from 'dma-ui-kit';
import styled from 'styled-components';
import { Box } from 'dma-ui-kit';

const Container = styled(Box)`
  padding: 0 12px;

  @media (min-width: 768px) {
      padding: 0 24px;
  }

  @media (min-width: 1024px) {
      padding: 0 48px;
  }    

  max-width: 1250px;
  margin-bottom: 10px;
  display: block;
`;

const VideoWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%; /* 16:9 aspect ratio */
    margin: 0 auto;
    
    video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

const VideoHeroWidget = (props) => {
    const { field_desktop_video, field_mobile_video, field_tablet_video } = props.paragraph.relationships;

    const autoPlay = (props.paragraph.attributes.field_behavior == 'autoplay_muted' || props.paragraph.attributes.field_behavior == 'autoplay_with_audio') ? true : false;
    const muted = (props.paragraph.attributes.field_behavior == 'autoplay_muted') ? true : false; 

    const desktop_media = field_desktop_video.data.relationships.field_media_video_file.data.attributes.uri.url;
    const tablet_media = field_tablet_video.data.relationships.field_media_video_file.data.attributes.uri.url;
    const mobile_media = field_mobile_video.data.relationships.field_media_video_file.data.attributes.uri.url;

    return (
        <Container>
            <VideoWrapper>
                <VideoPlayer
                    autoPlay={autoPlay}
                    muted={muted}
                    desktop={desktop_media}
                    tablet={tablet_media}
                    mobile={mobile_media}
                />
            </VideoWrapper>
        </Container>
    );
};

export default withRouter(VideoHeroWidget);
